// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"dd0243aba988160c1df4","303":"c4abb88b0bb9508caf0b","495":"2a4a15efa98a6351d20b"}[chunkId] + ".js";
};